// Copyright (c) 2016 Deere & Company

import './index.scss';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import { buildNumber } from '../../services/build-number';

const NumberOfRecordsFound = ({ count }) => (
    <div className="help-text">
        <FormattedMessage
            id="RECORDS_FOUND"
            values={{
                count,
                countToDisplay: buildNumber(count),
            }}
        />
    </div>
);

NumberOfRecordsFound.displayName = 'NumberOfRecordsFound';
NumberOfRecordsFound.propTypes = {
    count: PropTypes.number.isRequired,
};

export default NumberOfRecordsFound;
